import { useState, useCallback, useRef } from 'react';
import { searchPlaces } from '../utils/geocoding';

const DEBOUNCE_MS = 400;

export function useGeocoder() {
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const timerRef = useRef(null);
  const abortRef = useRef(null);

  const search = useCallback((query) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (!query.trim()) { setResults([]); return; }

    timerRef.current = setTimeout(async () => {
      if (abortRef.current) abortRef.current.abort();
      abortRef.current = new AbortController();

      setIsSearching(true);
      try {
        const data = await searchPlaces(query, abortRef.current.signal);
        setResults(data);
      } catch (err) {
        if (err.name !== 'AbortError') setResults([]);
      } finally {
        setIsSearching(false);
      }
    }, DEBOUNCE_MS);
  }, []);

  const clear = useCallback(() => {
    setResults([]);
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  return { results, isSearching, search, clear };
}
